import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionHeadline } from '@/components/SectionHeadline';
import { Text } from '@/components/typography';
import { Button } from '@/components/buttons';
import { LINKS } from '@/constants/links';
import { RepresentativeExample } from '@/sections/RepresentativeExample';
import ProductComparisonTable from '../ProductComparasion';
import { showSpringOffer } from '@/utils/springOffer';
import { SPRING_OFFER_TRANSLATION_VALUES } from '@/constants/springOffer';
function FilledComparisonTable() {
  const $ = _c(264);
  const {
    t
  } = useTranslation("ourProducts");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = showSpringOffer();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const shouldShowSpringOffer = t0;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div id="maxi" />;
    t2 = <div id="mini" />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="bgCircle absolute top-1/2 right-0 hidden translate-x-1/4 -translate-y-1/2 rotate-90 md:block" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("comparisonTable.title");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <SectionHeadline className="mb-12 md:mb-16" anchorKey="ourProducts.comparisonTable.title">{t4}</SectionHeadline>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("comparisonTable.columns.mini.title");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t("comparisonTable.columns.maxi.title");
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t("comparisonTable.columns.noPackage.title");
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t7 || $[16] !== t8) {
    t9 = {
      left: t6,
      center: t7,
      right: t8
    };
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t("comparisonTable.categories.1.title");
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("comparisonTable.categories.1.items.1.title");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t) {
    t12 = t("comparisonTable.categories.1.items.1.tooltip");
    $[22] = t;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11 || $[25] !== t12) {
    t13 = {
      title: t11,
      tooltip: t12,
      left: true,
      center: true,
      right: true
    };
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t) {
    t14 = t("comparisonTable.categories.1.items.2.title");
    $[27] = t;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t("comparisonTable.categories.1.items.2.tooltip");
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t14 || $[32] !== t15) {
    t16 = {
      title: t14,
      tooltip: t15,
      left: true,
      center: true,
      right: true
    };
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t) {
    t17 = t("comparisonTable.categories.1.items.3.title");
    $[34] = t;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t) {
    t18 = t("comparisonTable.categories.1.items.3.tooltip");
    $[36] = t;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t17 || $[39] !== t18) {
    t19 = {
      title: t17,
      tooltip: t18,
      left: true,
      center: true,
      right: false
    };
    $[38] = t17;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t) {
    t20 = t("comparisonTable.categories.1.items.4.title");
    $[41] = t;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t) {
    t21 = t("comparisonTable.categories.1.items.4.tooltip");
    $[43] = t;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t20 || $[46] !== t21) {
    t22 = {
      title: t20,
      tooltip: t21,
      left: false,
      center: true,
      right: false
    };
    $[45] = t20;
    $[46] = t21;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== t) {
    t23 = t("comparisonTable.categories.1.items.5.title");
    $[48] = t;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== t) {
    t24 = t("comparisonTable.categories.1.items.5.tooltip");
    $[50] = t;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t23 || $[53] !== t24) {
    t25 = {
      title: t23,
      tooltip: t24,
      left: false,
      center: true,
      right: false
    };
    $[52] = t23;
    $[53] = t24;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] !== t13 || $[56] !== t16 || $[57] !== t19 || $[58] !== t22 || $[59] !== t25) {
    t26 = [t13, t16, t19, t22, t25];
    $[55] = t13;
    $[56] = t16;
    $[57] = t19;
    $[58] = t22;
    $[59] = t25;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  let t27;
  if ($[61] !== t10 || $[62] !== t26) {
    t27 = {
      title: t10,
      items: t26
    };
    $[61] = t10;
    $[62] = t26;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  let t28;
  if ($[64] !== t) {
    t28 = t("comparisonTable.categories.2.title");
    $[64] = t;
    $[65] = t28;
  } else {
    t28 = $[65];
  }
  let t29;
  if ($[66] !== t) {
    t29 = t("comparisonTable.categories.2.items.1.title");
    $[66] = t;
    $[67] = t29;
  } else {
    t29 = $[67];
  }
  let t30;
  if ($[68] !== t) {
    t30 = t("comparisonTable.categories.2.items.1.tooltip");
    $[68] = t;
    $[69] = t30;
  } else {
    t30 = $[69];
  }
  let t31;
  if ($[70] !== t29 || $[71] !== t30) {
    t31 = {
      title: t29,
      tooltip: t30,
      left: true,
      center: true,
      right: true
    };
    $[70] = t29;
    $[71] = t30;
    $[72] = t31;
  } else {
    t31 = $[72];
  }
  let t32;
  if ($[73] !== t) {
    t32 = t("comparisonTable.categories.2.items.2.title");
    $[73] = t;
    $[74] = t32;
  } else {
    t32 = $[74];
  }
  let t33;
  if ($[75] !== t) {
    t33 = t("comparisonTable.categories.2.items.2.tooltip");
    $[75] = t;
    $[76] = t33;
  } else {
    t33 = $[76];
  }
  let t34;
  if ($[77] !== t32 || $[78] !== t33) {
    t34 = {
      title: t32,
      tooltip: t33,
      left: true,
      center: true,
      right: false
    };
    $[77] = t32;
    $[78] = t33;
    $[79] = t34;
  } else {
    t34 = $[79];
  }
  let t35;
  if ($[80] !== t) {
    t35 = t("comparisonTable.categories.2.items.3.title");
    $[80] = t;
    $[81] = t35;
  } else {
    t35 = $[81];
  }
  let t36;
  if ($[82] !== t) {
    t36 = t("comparisonTable.categories.2.items.3.tooltip");
    $[82] = t;
    $[83] = t36;
  } else {
    t36 = $[83];
  }
  let t37;
  if ($[84] !== t35 || $[85] !== t36) {
    t37 = {
      title: t35,
      tooltip: t36,
      left: false,
      center: true,
      right: false
    };
    $[84] = t35;
    $[85] = t36;
    $[86] = t37;
  } else {
    t37 = $[86];
  }
  let t38;
  if ($[87] !== t) {
    t38 = t("comparisonTable.categories.2.items.4.title");
    $[87] = t;
    $[88] = t38;
  } else {
    t38 = $[88];
  }
  let t39;
  if ($[89] !== t) {
    t39 = t("comparisonTable.categories.2.items.4.tooltip");
    $[89] = t;
    $[90] = t39;
  } else {
    t39 = $[90];
  }
  let t40;
  if ($[91] !== t) {
    t40 = t("comparisonTable.categories.2.items.4.left");
    $[91] = t;
    $[92] = t40;
  } else {
    t40 = $[92];
  }
  let t41;
  if ($[93] !== t) {
    t41 = t("comparisonTable.categories.2.items.4.center");
    $[93] = t;
    $[94] = t41;
  } else {
    t41 = $[94];
  }
  let t42;
  if ($[95] !== t) {
    t42 = t("comparisonTable.categories.2.items.4.right");
    $[95] = t;
    $[96] = t42;
  } else {
    t42 = $[96];
  }
  let t43;
  if ($[97] !== t38 || $[98] !== t39 || $[99] !== t40 || $[100] !== t41 || $[101] !== t42) {
    t43 = {
      title: t38,
      tooltip: t39,
      left: t40,
      center: t41,
      right: t42
    };
    $[97] = t38;
    $[98] = t39;
    $[99] = t40;
    $[100] = t41;
    $[101] = t42;
    $[102] = t43;
  } else {
    t43 = $[102];
  }
  let t44;
  if ($[103] !== t) {
    t44 = t("comparisonTable.categories.2.items.5.title");
    $[103] = t;
    $[104] = t44;
  } else {
    t44 = $[104];
  }
  let t45;
  if ($[105] !== t) {
    t45 = t("comparisonTable.categories.2.items.5.tooltip");
    $[105] = t;
    $[106] = t45;
  } else {
    t45 = $[106];
  }
  let t46;
  if ($[107] !== t) {
    t46 = t("comparisonTable.categories.2.items.5.left");
    $[107] = t;
    $[108] = t46;
  } else {
    t46 = $[108];
  }
  let t47;
  if ($[109] !== t) {
    t47 = t("comparisonTable.categories.2.items.5.center");
    $[109] = t;
    $[110] = t47;
  } else {
    t47 = $[110];
  }
  let t48;
  if ($[111] !== t) {
    t48 = t("comparisonTable.categories.2.items.5.right");
    $[111] = t;
    $[112] = t48;
  } else {
    t48 = $[112];
  }
  let t49;
  if ($[113] !== t44 || $[114] !== t45 || $[115] !== t46 || $[116] !== t47 || $[117] !== t48) {
    t49 = {
      title: t44,
      tooltip: t45,
      left: t46,
      center: t47,
      right: t48
    };
    $[113] = t44;
    $[114] = t45;
    $[115] = t46;
    $[116] = t47;
    $[117] = t48;
    $[118] = t49;
  } else {
    t49 = $[118];
  }
  let t50;
  if ($[119] !== t31 || $[120] !== t34 || $[121] !== t37 || $[122] !== t43 || $[123] !== t49) {
    t50 = [t31, t34, t37, t43, t49];
    $[119] = t31;
    $[120] = t34;
    $[121] = t37;
    $[122] = t43;
    $[123] = t49;
    $[124] = t50;
  } else {
    t50 = $[124];
  }
  let t51;
  if ($[125] !== t28 || $[126] !== t50) {
    t51 = {
      title: t28,
      items: t50
    };
    $[125] = t28;
    $[126] = t50;
    $[127] = t51;
  } else {
    t51 = $[127];
  }
  let t52;
  if ($[128] !== t) {
    t52 = t("comparisonTable.categories.3.title");
    $[128] = t;
    $[129] = t52;
  } else {
    t52 = $[129];
  }
  let t53;
  if ($[130] !== t) {
    t53 = t("comparisonTable.categories.3.items.1.title");
    $[130] = t;
    $[131] = t53;
  } else {
    t53 = $[131];
  }
  let t54;
  if ($[132] !== t) {
    t54 = t("comparisonTable.categories.3.items.1.tooltip");
    $[132] = t;
    $[133] = t54;
  } else {
    t54 = $[133];
  }
  let t55;
  if ($[134] !== t53 || $[135] !== t54) {
    t55 = {
      title: t53,
      tooltip: t54,
      left: true,
      center: true,
      right: false
    };
    $[134] = t53;
    $[135] = t54;
    $[136] = t55;
  } else {
    t55 = $[136];
  }
  let t56;
  if ($[137] !== t) {
    t56 = t("comparisonTable.categories.3.items.2.title");
    $[137] = t;
    $[138] = t56;
  } else {
    t56 = $[138];
  }
  let t57;
  if ($[139] !== t) {
    t57 = t("comparisonTable.categories.3.items.2.tooltip");
    $[139] = t;
    $[140] = t57;
  } else {
    t57 = $[140];
  }
  let t58;
  if ($[141] !== t56 || $[142] !== t57) {
    t58 = {
      title: t56,
      tooltip: t57,
      left: true,
      center: true,
      right: false
    };
    $[141] = t56;
    $[142] = t57;
    $[143] = t58;
  } else {
    t58 = $[143];
  }
  let t59;
  if ($[144] !== t) {
    t59 = t("comparisonTable.categories.3.items.3.title");
    $[144] = t;
    $[145] = t59;
  } else {
    t59 = $[145];
  }
  let t60;
  if ($[146] !== t) {
    t60 = t("comparisonTable.categories.3.items.3.tooltip");
    $[146] = t;
    $[147] = t60;
  } else {
    t60 = $[147];
  }
  let t61;
  if ($[148] !== t) {
    t61 = t("comparisonTable.categories.3.items.3.left");
    $[148] = t;
    $[149] = t61;
  } else {
    t61 = $[149];
  }
  let t62;
  if ($[150] !== t) {
    t62 = t("comparisonTable.categories.3.items.3.center");
    $[150] = t;
    $[151] = t62;
  } else {
    t62 = $[151];
  }
  let t63;
  if ($[152] !== t) {
    t63 = t("comparisonTable.categories.3.items.3.right");
    $[152] = t;
    $[153] = t63;
  } else {
    t63 = $[153];
  }
  let t64;
  if ($[154] !== t59 || $[155] !== t60 || $[156] !== t61 || $[157] !== t62 || $[158] !== t63) {
    t64 = {
      title: t59,
      tooltip: t60,
      left: t61,
      center: t62,
      right: t63
    };
    $[154] = t59;
    $[155] = t60;
    $[156] = t61;
    $[157] = t62;
    $[158] = t63;
    $[159] = t64;
  } else {
    t64 = $[159];
  }
  let t65;
  if ($[160] !== t) {
    t65 = t("comparisonTable.categories.3.items.4.title");
    $[160] = t;
    $[161] = t65;
  } else {
    t65 = $[161];
  }
  let t66;
  if ($[162] !== t) {
    t66 = t("comparisonTable.categories.3.items.4.tooltip");
    $[162] = t;
    $[163] = t66;
  } else {
    t66 = $[163];
  }
  let t67;
  if ($[164] !== t) {
    t67 = t("comparisonTable.categories.3.items.4.left");
    $[164] = t;
    $[165] = t67;
  } else {
    t67 = $[165];
  }
  let t68;
  if ($[166] !== t) {
    t68 = t("comparisonTable.categories.3.items.4.center");
    $[166] = t;
    $[167] = t68;
  } else {
    t68 = $[167];
  }
  let t69;
  if ($[168] !== t) {
    t69 = t("comparisonTable.categories.3.items.4.right");
    $[168] = t;
    $[169] = t69;
  } else {
    t69 = $[169];
  }
  let t70;
  if ($[170] !== t65 || $[171] !== t66 || $[172] !== t67 || $[173] !== t68 || $[174] !== t69) {
    t70 = {
      title: t65,
      tooltip: t66,
      left: t67,
      center: t68,
      right: t69
    };
    $[170] = t65;
    $[171] = t66;
    $[172] = t67;
    $[173] = t68;
    $[174] = t69;
    $[175] = t70;
  } else {
    t70 = $[175];
  }
  let t71;
  if ($[176] !== t) {
    t71 = t("comparisonTable.categories.3.items.5.title");
    $[176] = t;
    $[177] = t71;
  } else {
    t71 = $[177];
  }
  let t72;
  if ($[178] !== t) {
    t72 = t("comparisonTable.categories.3.items.5.tooltip");
    $[178] = t;
    $[179] = t72;
  } else {
    t72 = $[179];
  }
  let t73;
  if ($[180] !== t71 || $[181] !== t72) {
    t73 = {
      title: t71,
      tooltip: t72,
      left: false,
      center: true,
      right: false
    };
    $[180] = t71;
    $[181] = t72;
    $[182] = t73;
  } else {
    t73 = $[182];
  }
  let t74;
  if ($[183] !== t) {
    t74 = t("comparisonTable.categories.3.items.6.title");
    $[183] = t;
    $[184] = t74;
  } else {
    t74 = $[184];
  }
  let t75;
  if ($[185] !== t) {
    t75 = t("comparisonTable.categories.3.items.6.tooltip");
    $[185] = t;
    $[186] = t75;
  } else {
    t75 = $[186];
  }
  let t76;
  if ($[187] !== t74 || $[188] !== t75) {
    t76 = {
      title: t74,
      tooltip: t75,
      left: false,
      center: true,
      right: false
    };
    $[187] = t74;
    $[188] = t75;
    $[189] = t76;
  } else {
    t76 = $[189];
  }
  let t77;
  if ($[190] !== t) {
    t77 = shouldShowSpringOffer && {
      title: t("comparisonTable.categories.3.items.spring.title"),
      tooltip: t("comparisonTable.categories.3.items.spring.tooltip", SPRING_OFFER_TRANSLATION_VALUES),
      left: false,
      center: true,
      right: false
    };
    $[190] = t;
    $[191] = t77;
  } else {
    t77 = $[191];
  }
  let t78;
  if ($[192] !== t55 || $[193] !== t58 || $[194] !== t64 || $[195] !== t70 || $[196] !== t73 || $[197] !== t76 || $[198] !== t77) {
    t78 = [t55, t58, t64, t70, t73, t76, t77].filter(Boolean);
    $[192] = t55;
    $[193] = t58;
    $[194] = t64;
    $[195] = t70;
    $[196] = t73;
    $[197] = t76;
    $[198] = t77;
    $[199] = t78;
  } else {
    t78 = $[199];
  }
  let t79;
  if ($[200] !== t52 || $[201] !== t78) {
    t79 = {
      title: t52,
      items: t78
    };
    $[200] = t52;
    $[201] = t78;
    $[202] = t79;
  } else {
    t79 = $[202];
  }
  let t80;
  if ($[203] !== t) {
    t80 = t("comparisonTable.categories.4.title");
    $[203] = t;
    $[204] = t80;
  } else {
    t80 = $[204];
  }
  let t81;
  if ($[205] !== t) {
    t81 = t("comparisonTable.categories.4.items.1.title");
    $[205] = t;
    $[206] = t81;
  } else {
    t81 = $[206];
  }
  let t82;
  if ($[207] !== t) {
    t82 = t("comparisonTable.categories.4.items.1.tooltip");
    $[207] = t;
    $[208] = t82;
  } else {
    t82 = $[208];
  }
  let t83;
  if ($[209] !== t81 || $[210] !== t82) {
    t83 = {
      title: t81,
      tooltip: t82,
      left: true,
      center: true,
      right: true
    };
    $[209] = t81;
    $[210] = t82;
    $[211] = t83;
  } else {
    t83 = $[211];
  }
  let t84;
  if ($[212] !== t) {
    t84 = t("comparisonTable.categories.4.items.2.title");
    $[212] = t;
    $[213] = t84;
  } else {
    t84 = $[213];
  }
  let t85;
  if ($[214] !== t) {
    t85 = t("comparisonTable.categories.4.items.2.tooltip");
    $[214] = t;
    $[215] = t85;
  } else {
    t85 = $[215];
  }
  let t86;
  if ($[216] !== t84 || $[217] !== t85) {
    t86 = {
      title: t84,
      tooltip: t85,
      left: false,
      center: true,
      right: false
    };
    $[216] = t84;
    $[217] = t85;
    $[218] = t86;
  } else {
    t86 = $[218];
  }
  let t87;
  if ($[219] !== t) {
    t87 = t("comparisonTable.categories.4.items.3.title");
    $[219] = t;
    $[220] = t87;
  } else {
    t87 = $[220];
  }
  let t88;
  if ($[221] !== t) {
    t88 = t("comparisonTable.categories.4.items.3.tooltip");
    $[221] = t;
    $[222] = t88;
  } else {
    t88 = $[222];
  }
  let t89;
  if ($[223] !== t87 || $[224] !== t88) {
    t89 = {
      title: t87,
      tooltip: t88,
      left: false,
      center: true,
      right: false
    };
    $[223] = t87;
    $[224] = t88;
    $[225] = t89;
  } else {
    t89 = $[225];
  }
  let t90;
  if ($[226] !== t) {
    t90 = t("comparisonTable.categories.4.items.4.title");
    $[226] = t;
    $[227] = t90;
  } else {
    t90 = $[227];
  }
  let t91;
  if ($[228] !== t) {
    t91 = t("comparisonTable.categories.4.items.4.tooltip");
    $[228] = t;
    $[229] = t91;
  } else {
    t91 = $[229];
  }
  let t92;
  if ($[230] !== t90 || $[231] !== t91) {
    t92 = {
      title: t90,
      tooltip: t91,
      left: false,
      center: true,
      right: false
    };
    $[230] = t90;
    $[231] = t91;
    $[232] = t92;
  } else {
    t92 = $[232];
  }
  let t93;
  if ($[233] !== t83 || $[234] !== t86 || $[235] !== t89 || $[236] !== t92) {
    t93 = [t83, t86, t89, t92];
    $[233] = t83;
    $[234] = t86;
    $[235] = t89;
    $[236] = t92;
    $[237] = t93;
  } else {
    t93 = $[237];
  }
  let t94;
  if ($[238] !== t80 || $[239] !== t93) {
    t94 = {
      title: t80,
      items: t93
    };
    $[238] = t80;
    $[239] = t93;
    $[240] = t94;
  } else {
    t94 = $[240];
  }
  let t95;
  if ($[241] !== t27 || $[242] !== t51 || $[243] !== t79 || $[244] !== t94) {
    t95 = [t27, t51, t79, t94];
    $[241] = t27;
    $[242] = t51;
    $[243] = t79;
    $[244] = t94;
    $[245] = t95;
  } else {
    t95 = $[245];
  }
  let t96;
  if ($[246] !== t9 || $[247] !== t95) {
    t96 = <ProductComparisonTable activeColumn="center" titles={t9} categories={t95} />;
    $[246] = t9;
    $[247] = t95;
    $[248] = t96;
  } else {
    t96 = $[248];
  }
  let t97;
  if ($[249] !== t) {
    t97 = t("comparisonTable.text");
    $[249] = t;
    $[250] = t97;
  } else {
    t97 = $[250];
  }
  let t98;
  if ($[251] !== t97) {
    t98 = <Text variant="p4" className="my-10 text-center">{t97}</Text>;
    $[251] = t97;
    $[252] = t98;
  } else {
    t98 = $[252];
  }
  let t99;
  if ($[253] === Symbol.for("react.memo_cache_sentinel")) {
    t99 = <div className="mx-auto mt-4 max-w-[47.5rem] md:my-16 lg:my-12"><RepresentativeExample className="bg-blue-50" /></div>;
    $[253] = t99;
  } else {
    t99 = $[253];
  }
  let t100;
  if ($[254] === Symbol.for("react.memo_cache_sentinel")) {
    t100 = LINKS();
    $[254] = t100;
  } else {
    t100 = $[254];
  }
  const t101 = t100.registration;
  let t102;
  if ($[255] !== t) {
    t102 = t("comparisonTable.cta");
    $[255] = t;
    $[256] = t102;
  } else {
    t102 = $[256];
  }
  let t103;
  if ($[257] !== t102) {
    t103 = <div className="pt-4"><Button variant="primary" align="center" size="lg" to={t101} testId="accountsRegistration" analyticsParam="accountsRegistration">{t102}</Button></div>;
    $[257] = t102;
    $[258] = t103;
  } else {
    t103 = $[258];
  }
  let t104;
  if ($[259] !== t103 || $[260] !== t5 || $[261] !== t96 || $[262] !== t98) {
    t104 = <>{t1}{t2}<div className="relative px-4" id="comparison-table">{t3}<div className="relative z-10">{t5}{t96}{t98}{t99}{t103}</div></div></>;
    $[259] = t103;
    $[260] = t5;
    $[261] = t96;
    $[262] = t98;
    $[263] = t104;
  } else {
    t104 = $[263];
  }
  return t104;
}
export default FilledComparisonTable;